import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WheelService } from '../wheel.service';
import { WheelBetSectionComponent } from '../wheel-bet-section/wheel-bet-section.component';
import { WheelMainComponent } from '../wheel-main/wheel-main.component';
import { WheelHistoryComponent } from '../wheel-history/wheel-history.component';
import { WheelColorRowComponent } from '../wheel-color-row/wheel-color-row.component';

@Component({
  selector: 'app-wheel',
  templateUrl: './wheel.component.html',
  styleUrls: ['./wheel.component.scss'],
  standalone: true,
  imports: [
    WheelBetSectionComponent,
    WheelMainComponent,
    WheelHistoryComponent,
    WheelColorRowComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WheelComponent {
  constructor(public wheelService: WheelService) {}
}
